import * as S from './style';
import donationImg from '@/assets/img/banner/donation.png';

const SponsorInformation = () => (
	<S.ConferenceBoardBox>
		<S.ContentBox>
			<img src={donationImg} alt="후원안내 이미지" />

			<S.ContentTitle>후원을 원하시는 업체 및 연구단 담당자께서는 한국노화학회 사무국(aging07@gmail.com)으로 연락 바랍니다. </S.ContentTitle>
		</S.ContentBox>
		{/* <S.ContentBox>
			<S.ContentTitle>초록집 광고 및 기타 후원</S.ContentTitle>
			<S.ScheduleBox>
				<S.ScheduleContent>
					<S.BorderBox>초록집 광고</S.BorderBox>
					<p>추후 안내</p>
				</S.ScheduleContent>
				<S.ScheduleContent>
					<S.BorderBox>홈페이지 배너</S.BorderBox>
					<p>추후 안내</p>
				</S.ScheduleContent>
				<S.ScheduleContent>
					<S.BorderBox>광고없이 후원</S.BorderBox>
					<p>추후 안내</p>
				</S.ScheduleContent>
			</S.ScheduleBox>
		</S.ContentBox> */}
		{/* <S.ContentBox>
			<S.ContentTitle>장소</S.ContentTitle>
			<S.ImgMapBox><img src={locationImg} alt="장소 이미지" /></S.ImgMapBox>
		</S.ContentBox> */}
	</S.ConferenceBoardBox>
);

export default SponsorInformation;
